import './App.css';
import { OdooConfig } from './utilities/odoo-config';
import { useEffect } from 'react';
import Routes from './routes.js';
import Odoo from 'odoo-xmlrpc';

function App() {
  useEffect(() => {
    const initialiceData = async () => {
      const config = await OdooConfig();
      
      const odoo = new Odoo({
        url: config.host,
        port: config.port,
        db: config.database
      });

      console.log("el odoo", odoo);
    }
    
    initialiceData()
  }, []);

  return <Routes />;
}

export default App;